import { Button } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

import { useClearLocationFilter } from './hooks/useClearLocationFilter';

export const ClearLocationFilter: React.FC = () => {
	const {
		data: { hideButton },
		actions: { clearRefine },
	} = useClearLocationFilter();

	if (hideButton) return null;

	return (
		<Button variant="secondary" onClick={clearRefine} size="small">
			<Translate value="corgi.search.filters.clear_filters.clear" />
		</Button>
	);
};
